export type TooltipAction = "open" | "close" | "toggle";

interface TooltipActions {
  OPEN: TooltipAction;
  CLOSE: TooltipAction;
  TOGGLE: TooltipAction;
}

export const TOOLTIP_ACTIONS: TooltipActions = {
  OPEN: "open",
  CLOSE: "close",
  TOGGLE: "toggle",
};
